/** One gesture-unlocked context for both game music and the birth intro. */
let sharedContext: AudioContext | null = null

export function getAudioContext(): AudioContext | null {
  if (sharedContext && sharedContext.state !== 'closed') return sharedContext
  if (typeof window === 'undefined') return null
  const AudioContextClass = window.AudioContext || (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
  if (!AudioContextClass) return null
  try {
    sharedContext = new AudioContextClass()
    return sharedContext
  } catch {
    sharedContext = null
    return null
  }
}

export function isAudioRunning(context: AudioContext): boolean {
  // Some embedded Web Audio implementations do not expose state.
  return !context.state || context.state === 'running'
}

export function resumeAudioContext(context: AudioContext): Promise<void> {
  if (isAudioRunning(context) || typeof context.resume !== 'function') return Promise.resolve()
  try {
    // Do not cache this promise: a blocked resume can stay pending until the
    // next gesture, which must be allowed to issue another resume immediately.
    return Promise.resolve(context.resume()).catch(() => undefined)
  } catch {
    return Promise.resolve()
  }
}
